import {
  campaignDtoSchema,
  campaignTrackItemSchema,
  mapCampaignDtoToCampaign,
} from '../campaign-schema';
import type { CampaignDetailData } from '../campaign-type';
import type { CampaignDetailResponse } from '../generated/campaign-type';

function normalizeCampaignDetailItem(item: CampaignDetailResponse['items'][number]) {
  const { label, ...rest } = item;

  return label == null ? rest : { ...rest, label };
}

export function mapCampaignDetailResponseToCampaignDetail(
  response: CampaignDetailResponse,
): CampaignDetailData {
  const campaign = mapCampaignDtoToCampaign(campaignDtoSchema.parse(response));
  const items = campaignTrackItemSchema
    .array()
    .parse(response.items.map(normalizeCampaignDetailItem));

  return { ...campaign, items };
}
